import React from 'react';
import { RegistrationModal } from './auth/RegistrationModal';
import './SoftGate.css';

interface SoftGateProps {
  onDismiss?: () => void;
  nextTestId?: string; // Next test to load after sign-up
}

export const SoftGate: React.FC<SoftGateProps> = ({ onDismiss, nextTestId }) => {
  const handleRegistrationSuccess = (_user: unknown) => {
    // After successful registration, stay on results page
    // Store current testId (from localStorage set by PracticeTest) for AuthCallback
    const currentTestId = localStorage.getItem('currentResultsTestId');
    if (currentTestId) {
      localStorage.setItem('pendingReturnTestId', currentTestId);
      localStorage.setItem('returnToResults', 'true'); // Ensure results page is shown after sign-up
    }
    
    // Dismiss gate - user stays on current results page
    if (onDismiss) {
      onDismiss();
    }
  };

  return (
    <div className="soft-gate-shell">
      <RegistrationModal
        isOpen={true}
        onClose={() => {
          if (onDismiss) {
            onDismiss();
          }
        }}
        onSuccess={handleRegistrationSuccess}
        nextTestId={nextTestId}
      />
    </div>
  );
};

